<template>
    <div class="mediver-login-container">
        <div class="mediver-login-logo">
<!--            <h2 class="main-title">Electroceuticals</h2>-->
<!--            <div class="sub-title">Next-Generation Digital Medicine</div>-->
            <!-- 로고 이미지를 추가하려면 아래 주석 해제 -->
            <img src="@/assets/resource/icon/MEDIVER CI.png" alt="Electroceuticals" class="login-logo-img" />
        </div>
        <form class="mediver-login-box" @submit.prevent="login">
            <input
                v-model="hospitalCode"
                @input="hospitalCode = $event.target.value.replace(/\s/g, '')"
                type="text"
                class="login-input"
                placeholder="병원 코드"
                autocomplete="hospitalCode"
                maxlength="100"
            />
            <input
                v-model="email"
                @input="email = $event.target.value.replace(/\s/g, '')"
                type="text"
                class="login-input"
                placeholder="이메일"
                autocomplete="email"
                maxlength="200"
            />
            <input
                v-model="password"
                @input="password = $event.target.value.replace(/\s/g, '')"
                type="password"
                class="login-input"
                placeholder="비밀번호"
                autocomplete="current-password"
                maxlength="30"
            />
            <div class="login-options-row">
                <div class="login-options">
                    <input type="checkbox" v-model="saveLogin" id="saveLogin" />
                    <label class="auto-login" for="saveLogin">로그인 정보 저장</label>
                </div>
                <div class="login-options">
                    <input type="checkbox" v-model="autoLogin" id="autoLogin" />
                    <label class="auto-login" for="autoLogin">자동로그인</label>
                </div>
            </div>
            <button type="submit" class="login-btn">로그인</button>
            <div v-if="error" class="login-error">{{ error }}</div>
            <div class="login-links">
                <span class="link" @click="openIDModal">아이디 찾기</span>
                <span class="divider">|</span>
                <span class="link" @click="openPasswordModal">비밀번호 찾기</span>
                <span class="divider">|</span>
                <span class="link" @click="openRegisterModal">회원가입</span>
            </div>
        </form>
        <!-- 아이디 찾기 모달 -->
        <div v-if="showIDModal" class="modal-overlay"><!-- @click.self="closeIDModal"-->
            <div class="modal-content">
                <button class="modal-close" @click="closeIDModal">×</button>
                <!-- Register 컴포넌트 호출 -->
                <ID
                    @toLogin="closeIDModal"
                    @toResetPassword="goFindPassword"
                    @toRegister="goRegister"
                />
            </div>
        </div>
        <!-- 비밀번호 찾기 모달 -->
        <div v-if="showPasswordModal" class="modal-overlay" ><!--@click.self="closePasswordModal"-->
            <div class="modal-content">
                <button class="modal-close" @click="closePasswordModal">×</button>
                <!-- Register 컴포넌트 호출 -->
                <Password
                    @toLogin="closePasswordModal"
                    @toRegister="goRegister"
                    @toFindId="goFindID"
                    @status="getStatus"
                />
            </div>
        </div>
        <!-- 임시비밀번호 재설정 모달 -->
        <div v-if="showTempPasswordModal" class="modal-overlay"><!-- @click.self="closeTempPasswordModal"-->
            <div class="modal-content tempPwModal">
                <button class="modal-close" @click="closeTempPasswordModal">×</button>
                <!-- TempPassword 컴포넌트 호출 -->
                <TempPassword
                    @toLogin="closeTempPasswordModal"
                    @toRegister="goRegister"
                    @toFindId="goFindID"
                    :email="tempEmail"
                    @status="getFlag"
                />
            </div>
        </div>
        <!-- 회원가입 모달 -->
        <div v-if="showRegisterModal" class="modal-overlay"><!-- @click.self="closeRegisterModal"-->
            <div class="modal-content">
                <button class="modal-close" @click="closeRegisterModal">×</button>
                <!-- Register 컴포넌트 호출 -->
                <Register
                    @toLogin="closeRegisterModal"
                    @toResetPassword="goFindPassword"
                    @toFindId="goFindID"
                />
            </div>
        </div>
    </div>
</template>
<script>
    import ID               from '@/components/common/FindID.vue';
    import Password         from '@/components/common/FindPassword.vue';
    import TempPassword     from '@/components/common/FindTempPassword.vue';
    import Register         from '@/components/common/Register.vue';
    import { commonUtils }  from "@/utils/commonUtils";
    import {useAuthStore}   from "@/stores/auth";
    import api, {urls}      from "@/api";
    import { useAppAlert }  from '@/composables/useAppAlert';

    const { showAlert, showAlertAndMove, confirm } = useAppAlert()

    export default {
        name: 'Login',
        components: { ID, Password, TempPassword, Register },
        data() {
            return {
                hospitalCode          : '',
                email                 : '',
                password              : '',
                error                 : '',
                autoLogin             : false,
                saveLogin             : false,
                showIDModal           : false,
                showPasswordModal     : false,
                showTempPasswordModal : false,
                showRegisterModal     : false,
                tempEmail             : '',
                authStore             : null,
            }
        },
        // async created() {
        created() {
            const { useAuthStore } = require('@/stores/auth')
            this.authStore = useAuthStore()

            // localStorage에서 로그인 정보 불러오기
            const savedCode  = localStorage.getItem('savedHospitalCode');
            const savedEmail = localStorage.getItem('savedEmail');

            if (savedCode && savedEmail) {
                this.hospitalCode = savedCode;
                this.email        = savedEmail;
                this.saveLogin    = true;
            }
        },
        async mounted() {
            // 자동로그인 방지 플래그 확인 후 제거
            const preventAutoLogin = localStorage.getItem('preventAutoLogin');
            // 자동로그인
            const savedAutoLogin = localStorage.getItem('autoLogin');
            
            if(savedAutoLogin == 'true'){

                this.autoLogin = true;
                const refreshToken = localStorage.getItem('refreshToken');

                if (!refreshToken) return

                // if(refreshToken){
                //     if (preventAutoLogin === 'true') {
                //         localStorage.removeItem('preventAutoLogin');
                //         return
                //     }
                //     try {
                //         const device = commonUtils.getDeviceInfo()
                //         const result = await this.authStore.refreshAccessToken({
                //             refreshToken: refreshToken,
                //             serialNumber: device
                //         })

                //         if(result){
                //             this.$router.push('/main')
                //         }
                //     } catch(err) {
                //         localStorage.removeItem('refreshToken')
                //         localStorage.removeItem('autoLogin')
                //         this.autoLogin = false
                //     }
                // }
                if (preventAutoLogin === 'true') {
                    localStorage.removeItem('preventAutoLogin');
                    return
                }
                try {
                    const device = commonUtils.getDeviceInfo()
                    const result = await this.authStore.refreshAccessToken({
                        refreshToken: refreshToken,
                        serialNumber: device
                    })

                    if(result){
                        this.$router.push('/main')
                    }
                } catch(err) {
                    localStorage.removeItem('refreshToken')
                    localStorage.removeItem('autoLogin')
                    this.autoLogin = false
                }
            }
        },
        methods: {
            getStatus(data){
                if(data){
                    this.tempEmail = data
                    this.showPasswordModal = false
                    this.showTempPasswordModal = true
                }
            },
            getFlag(data){
                if(data){
                    this.tempEmail = ''
                    this.showTempPasswordModal = false
                }
            },
            async login() {
                if(!this.hospitalCode){
                    showAlert('병원코드를 입력해주세요.')
                    return
                }
                if(!this.email){
                    showAlert('이메일을 입력해주세요.')
                    return
                }
                if(!this.password){
                    showAlert('비밀번호를 입력해주세요.')
                    return
                }

                const checkResult  = await api.post(urls.login.checkActiveLogin, {email: this.email});
                
                if (checkResult.data.active === 1) {
                    // const proceed = confirm('이미 다른 기기에서 로그인 중입니다. 계속 로그인하시겠습니까?');
                    const proceed = await confirm('이미 다른 기기에서 로그인 중입니다. 계속 로그인하시겠습니까?');
                    if (!proceed) {
                        return; // 취소 시 로그인 중단
                    }
                }
                
                const result = await this.authStore.login({instCd: this.hospitalCode, email: this.email, password: this.password, serialNumber: commonUtils.getDeviceInfo()})
                
                this.error = result.error
                
                const status = result.status
                
                if(status == 'temp_password' || status == 'over_count'){
                    showAlert(this.error)
                    this.tempEmail = this.email
                    this.showTempPasswordModal = true
                }

                // 로그인 정보 저장 여부에 따라 localStorage 저장/삭제 처리
                if(status == 'success'){
                    if (this.saveLogin) {
                        localStorage.setItem('savedHospitalCode', this.hospitalCode);
                        localStorage.setItem('savedEmail', this.email);
                    } else {
                        localStorage.removeItem('savedHospitalCode');
                        localStorage.removeItem('savedEmail');
                    }

                    // 아래 자동로그인 처리와 함께 메인 페이지 이동
                    if (this.autoLogin) {
                        localStorage.setItem('autoLogin', 'true');
                        const refreshToken = result.refreshToken;
                        if(refreshToken){
                            localStorage.setItem('refreshToken', refreshToken);
                        }
                    } else {
                        localStorage.removeItem('autoLogin');
                        localStorage.removeItem('refreshToken');
                    }

                    const authStore     = useAuthStore();
                    const updatedAtStr  = authStore.getUser?.updated_at || authStore.updated_at || '';
                    const updatedAt     = new Date(updatedAtStr);
                    const now           = new Date();

                    // 6개월(약 182일)을 밀리초로 환산
                    const sixMonthsMs = 182 * 24 * 60 * 60 * 1000;

                    if (now - updatedAt > sixMonthsMs) {
                        showAlert('비밀번호를 변경한 지 6개월이 지났습니다. 비밀번호 변경을 권장합니다.');
                    }
                    // this.$router.push('/main')
                    await this.$router.push('/main')
                }
            },
            openIDModal() {
                this.showIDModal = true;
            },
            openPasswordModal() {
                this.showPasswordModal = true;
            },
            openRegisterModal() {
                this.showRegisterModal = true;
            },
            closeIDModal() {
                this.showIDModal = false;
            },
            closePasswordModal() {
                this.showPasswordModal = false;
            },
            closeTempPasswordModal() {
                this.tempEmail = ''
                this.showTempPasswordModal = false;
            },
            closeRegisterModal() {
                this.showRegisterModal = false;
            },
            goFindID() {
                this.showPasswordModal = false;
                this.showRegisterModal = false;
                this.showIDModal = true;
            },
            goFindPassword() {
                this.showIDModal = false;
                this.showRegisterModal = false;
                this.showPasswordModal = true;
            },
            goRegister() {
                this.showIDModal = false;
                this.showPasswordModal = false;
                this.showRegisterModal = true;
            },
        }
    }
</script>